var $protobuf = {util:{},roots:{default:{}}};
// Common aliases
var $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export var AnnotationMetaDataChangeEvent = (function() {

    /**
     * Properties of an AnnotationMetaDataChangeEvent.
     * @exports IAnnotationMetaDataChangeEvent
     * @interface IAnnotationMetaDataChangeEvent
     * @property {string|null} [sessionKey] AnnotationMetaDataChangeEvent sessionKey
     * @property {string|null} [annotationType] AnnotationMetaDataChangeEvent annotationType
     * @property {number|null} [annotationState] AnnotationMetaDataChangeEvent annotationState
     * @property {string|null} [workflowId] AnnotationMetaDataChangeEvent workflowId
     */

    /**
     * Constructs a new AnnotationMetaDataChangeEvent.
     * @exports AnnotationMetaDataChangeEvent
     * @classdesc Represents an AnnotationMetaDataChangeEvent.
     * @implements IAnnotationMetaDataChangeEvent
     * @constructor
     * @param {IAnnotationMetaDataChangeEvent=} [properties] Properties to set
     */
    function AnnotationMetaDataChangeEvent(properties) {
        if (properties)
            for (var prop in properties)
                if (properties[prop] != null)
                    this[prop] = properties[prop];
    }

    /**
     * AnnotationMetaDataChangeEvent sessionKey.
     * @member {string} sessionKey
     * @memberof AnnotationMetaDataChangeEvent
     * @instance
     */
    AnnotationMetaDataChangeEvent.prototype.sessionKey = "";

    /**
     * AnnotationMetaDataChangeEvent annotationType.
     * @member {string} annotationType
     * @memberof AnnotationMetaDataChangeEvent
     * @instance
     */
    AnnotationMetaDataChangeEvent.prototype.annotationType = "";

    /**
     * AnnotationMetaDataChangeEvent annotationState.
     * @member {number} annotationState
     * @memberof AnnotationMetaDataChangeEvent
     * @instance
     */
    AnnotationMetaDataChangeEvent.prototype.annotationState = 0;

    /**
     * AnnotationMetaDataChangeEvent workflowId.
     * @member {string} workflowId
     * @memberof AnnotationMetaDataChangeEvent
     * @instance
     */
    AnnotationMetaDataChangeEvent.prototype.workflowId = "";

    /**
     * Gets the default type url for AnnotationMetaDataChangeEvent
     * @function getTypeUrl
     * @memberof AnnotationMetaDataChangeEvent
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AnnotationMetaDataChangeEvent.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AnnotationMetaDataChangeEvent";
    };

    return AnnotationMetaDataChangeEvent;
})();
